<template>
  <v-container>
    <LoadingBanner v-if="loading"/>
    <ErrorBanner v-else-if="!loading && devis === null"/>
    <div v-if="devis !== null">

      <v-row no-gutters justify="space-between">
        <h1 class="primary--text">
          DEVIS
        </h1>
        <v-btn text color="primary" :to="'/dossier/' + devis.dossier">
          <v-icon>mdi-arrow-left</v-icon>
          Retour au dossier
        </v-btn>
      </v-row>
      <v-row v-if="hasInvalidOperation" class="my-4">
        <v-col class="orange lighten-4 orange--text font-weight-bold rounded" cols="10" offset="1">
          <span>Attention, certaines lignes de ce devis ont été créés à partir de ligne du référentiel non validés par l'administration.</span><br>
        </v-col>
      </v-row>
      <span v-if="devis.archived" class="orange--text font-weight-bold">Ce devis est archivé.</span>
      <span v-if="devis.main" class="primary--text font-weight-bold">Ce devis est défini comme principal.</span>
      <v-row class="my-2" justify="center" no-gutters>
        <v-col cols="12">
          <h2 class="primary--text">Type de devis</h2>
          <span>{{ types[devis.type] }}</span>


        </v-col>
      </v-row>
      <v-row no-gutters justify="space-between">
        <v-btn v-if="!devis.archived && (isIntern || isMaitreOeuvre)" @click="changeType" color="primary">
          <v-icon>mdi-cog</v-icon>
          Transformer en devis &nbsp;<span v-if="devis.type === 'normal'">importé</span> <span v-else>normal</span>
        </v-btn>
        <div>
          <v-progress-circular indeterminate color="primary" v-if="duplicating"></v-progress-circular>
          <v-btn @click="duplicate" v-if="isIntern || isMaitreOeuvre" :disabled="duplicating" color="primary">
            <v-icon>mdi-copy</v-icon>
            Dupliquer le devis
          </v-btn>
          <v-btn class="mx-4" @click="switchMainStatus" v-if="isIntern || isMaitreOeuvre" :disabled="duplicating" color="primary">
            <v-icon>mdi-copy</v-icon>
            <span v-if="devis.main === false">Définir comme principal</span>
            <span v-else>Retirer en principal</span>
          </v-btn>

        </div>
      </v-row>
      <v-row class="my-4" no-gutters>
        <v-col class="text-center px-2" md="3" cols="12">
          <v-card color="red" class="text-center">
            <v-card-subtitle class="ml-4 white--text">
              <h2>Nom du devis</h2>
              <!-- TODO : Remettre le nom -->
              <h2>{{ devis.name !== null ? devis.name : "Non défini" }}</h2>
            </v-card-subtitle>
          </v-card>
          <EditDevisName v-if="isIntern || isMaitreOeuvre" :devis="devis" @reload-devis="loadDevis"/>
        </v-col>
        <v-col class="text-center px-2" md="3" cols="12">
          <v-card color="primary" class="text-center">
            <v-card-subtitle class="ml-4 white--text">
              <h2>Montant total TTC</h2>
              <h2>{{ formatNumber(devis.total_ttc) }}</h2>
            </v-card-subtitle>
          </v-card>
          <EditMontantDevisDialog @reload-devis="loadDevis" :devis="devis"/>
        </v-col>
        <v-col class="text-center px-2" md="3" cols="12">
          <v-card color="orange" class="text-center">
            <v-card-subtitle class="ml-4 white--text">
              <h2>Date du devis</h2>
              <h2 v-if="devis.proposal_date">{{ getFormattedDate(devis.proposal_date) }}</h2>
              <h2 v-else>Non défini</h2>
            </v-card-subtitle>
          </v-card>
          <EditDateDevisDialog v-if="isIntern || isMaitreOeuvre" :devis="devis" @reload-devis="loadDevis"/>
        </v-col>
        <v-col class="text-center px-2" md="3" cols="12">
          <v-card color="blue" class="darken-2 text-center">
            <v-card-subtitle class="ml-4 white--text">
              <h2>Document du devis</h2>
              <h2 v-if="devis.proposal_file"><a class="white--text text-decoration-none" target="_blank"
                                                :href="devis.proposal_file">Voir le document</a></h2>
              <h2 v-else>Non défini</h2>
            </v-card-subtitle>
          </v-card>
          <EditFileDevisDialog v-if="isIntern || isMaitreOeuvre" :devis="devis" @reload-devis="loadDevis"/>
          <br>
          <SignDevisForm v-if="isIntern || isMaitreOeuvre" class="mt-4" :devis="devis" @reload-devis="loadDevis"/>
          <p v-if="devis.proposal_file && devis.proposal_file.includes('sign')" class="blue--text">Devis signé, le
            re-signer effaçerait la signature actuelle.</p>
        </v-col>
      </v-row>
      <v-row v-if="isIntern || isMaitreOeuvre" class="my-2" justify="center" align="center">
        <v-btn to="/admin/referentiel" color="primary">Ajouter des opérations</v-btn>
      </v-row>
      <v-row class="my-2" justify="center" align="center">
        <p class="primary--text">
          <v-icon>mdi-exclamation-point</v-icon>
          En mode importé, entrer les opérations permet de rentrer par l'assignation des travaux.
        </p>
      </v-row>
      <v-row no-gutters class="my-2" justify="center" align="center">
        <span class="primary--text" @click="presentation = 'complete'" v-if="presentation ==='simple'"><v-icon>mdi-table-of-contents</v-icon> Vue simple</span>
        <span class="primary--text" @click="presentation = 'simple'" v-else-if="presentation ==='complete'"><v-icon>mdi-table</v-icon> vue complète</span>
      </v-row>
      <v-simple-table v-if="devis !== null && presentation === 'simple'" >
        <template v-slot:default>
          <thead>
          <tr>
            <th>Catégorie</th>
            <th>Code</th>
            <th>Description</th>
            <th>Unité</th>
            <th>Montant</th>
            <th>Quantité</th>
            <th style="min-width: 100px">Sous-total</th>
            <th>Observations</th>
            <th>X</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><v-select :items="categories" v-model="filterCategory" item-text="name" item-value="id"></v-select></td>
          </tr>
          <tr v-for="operation in operations" :key="operation.id">
            <td v-if="operation.category !== null">{{ operation.category.name }}</td>
            <td v-else>Sans catégorie</td>
            <td>{{ operation.code }}</td>
            <td>{{ operation.description }}</td>
            <td>{{ operation.unit }}</td>
            <td>{{ formatNumber(operation.price) }}</td>
            <td>{{ operation.quantity }}</td>
            <td>{{ formatNumber(operation.subtotal) }}</td>
            <td>{{ operation.observations }}</td>
            <td>
              <div v-if="isIntern || isMaitreOeuvre">
                <v-icon @click="deleteOperation(operation)" color="red">mdi-trash-can</v-icon>
                <EditDevisOperation @reload-devis="loadDevis" :operation="operation"/>
                <v-tooltip v-if="!operation.validated" bottom>
                  <template v-slot:activator="{on, attrs}">
                    <v-icon v-on="on" v-bind="attrs" color="orange">mdi-alert</v-icon>
                  </template>
                  <span>Non validé</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
          <tr v-if="!devis.archived && (isIntern || isMaitreOeuvre)">
            <td>
              <v-select :items="categories" v-model="categoryModel" item-text="name" item-value="id"></v-select>
            </td>
            <td colspan="4">
              <v-autocomplete :items="filtered_referentiel" return-object item-text="referentiel_name" item-value="id"
                              label="Opération"
                              v-model="referentielModel"></v-autocomplete>
            </td>
            <td>
              <v-text-field type="number" step="1" label="Quantité" v-model="quantity"></v-text-field>
            </td>
            <td colspan="2">
              <v-textarea v-model="observations" label="Observations"></v-textarea>
            </td>
            <td>
              <v-icon @click="addOperation" large color="primary">mdi-plus</v-icon>
            </td>
          </tr>
          <tr>
            <td colspan="4"><strong>Sous-total</strong></td>
            <td>{{ formatNumber(total_operations_ht) }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3"><strong>Total</strong></td>
            <td><strong>TVA : 2.10%</strong></td>
            <td>{{ formatNumber(total_operations_ttc) }}</td>
            <td></td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
        <v-simple-table v-else-if="devis != null && presentation === 'complete'">
          <template v-slot:default>
          <thead>
          <tr>
            <th>Catégorie</th>
            <th>Code</th>
            <th>Description</th>
            <th>Unité</th>
            <th>Montant</th>
            <th>Quantité</th>
            <th style="min-width: 100px">Sous-total</th>
            <th style="min-width: 400px">Observations</th>
            <th>X</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><v-select :items="categories" v-model="filterCategory" item-text="name" item-value="id"></v-select></td>
          </tr>
          <tr v-for="operation in operations_referentiel" :key="operation.id" :class="operation.operation_id !== null ? 'primary-accent' : ''">
            <td v-if="operation.category !== null">{{ operation.category.name }}</td>
            <td v-else>Sans catégorie</td>
            <td>{{ operation.code }}</td>
            <td>{{ operation.description }}</td>
            <td>{{ operation.unit }}</td>
            <td>{{ formatNumber(operation.price) }}</td>
            <td><v-text-field label="Quantité" type="number" v-model="operation.quantity"></v-text-field></td>
            <td>{{ formatNumber(operation.quantity * operation.price) }}</td>
            <td><v-text-field label="Commentaire" v-model="operation.observations"></v-text-field></td>
            <td>
              <div v-if="isIntern || isMaitreOeuvre">
                <v-icon v-if="operation.operation_id != null" @click="deleteOperation(operation)" color="red">mdi-trash-can</v-icon>
                <v-icon class="primary--text" @click="validateOperation(operation)">{{ operation.operation_id !== null ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
                <v-tooltip v-if="!operation.validated" bottom>
                  <template v-slot:activator="{on, attrs}">
                    <v-icon v-on="on" v-bind="attrs" color="orange">mdi-alert</v-icon>
                  </template>
                  <span>Non validé</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
          <tr v-if="!devis.archived && (isIntern || isMaitreOeuvre)">
            <td>
              <v-select :items="categories" v-model="categoryModel" item-text="name" item-value="id"></v-select>
            </td>
            <td colspan="4">
              <v-autocomplete :items="filtered_referentiel" return-object item-text="referentiel_name" item-value="id"
                              label="Opération"
                              v-model="referentielModel"></v-autocomplete>
            </td>
            <td>
              <v-text-field type="number" step="1" label="Quantité" v-model="quantity"></v-text-field>
            </td>
            <td colspan="2">
              <v-textarea v-model="observations" label="Observations"></v-textarea>
            </td>
            <td>
              <v-icon @click="addOperation" large color="primary">mdi-plus</v-icon>
            </td>
          </tr>
          <tr>
            <td colspan="4"><strong>Sous-total</strong></td>
            <td>{{ formatNumber(total_operations_ht) }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3"><strong>Total</strong></td>
            <td><strong>TVA : 2.10%</strong></td>
            <td>{{ formatNumber(total_operations_ttc) }}</td>
            <td></td>
          </tr>
          </tbody>
        </template>
        </v-simple-table>
      <v-simple-table>
        <template>
          <thead>
          <tr>
            <th>Catégorie</th>
            <th>Total</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="total in categories_total" :key="total.category">
            <td>{{ total.category }}</td>
            <td>{{ formatNumber(total.total) }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Total HT</td>
            <td class="font-weight-bold">{{ formatNumber(total_operations_ht) }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-row class="my-2" no-gutters justify="center" align="center"
             v-if="devis.type === 'import' && devis.operations.length > 0 && total_operations_ttc !== montantTotal">
        <p class="orange--text">Attention, le montant total du devis importé est différent du montant total des
          opérations rajoutés.</p>
      </v-row>
      <v-row no-gutters justify="center" align-content="center">
        <v-btn v-if="isIntern" color="red" class="white--text" @click="deleteDevis">Supprimer le
          devis
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import LoadingBanner from "@/components/home/LoadingBanner";
import ErrorBanner from "@/components/home/ErrorBanner";
import EditDevisOperation from "@/views/EditDevisOperation";
import EditMontantDevisDialog from "@/views/EditMontantDevisDialog";
import {DateUtilMixin} from "@/mixins/DateUtilMixin";
import EditDateDevisDialog from "@/views/EditDateDevisDialog";
import EditFileDevisDialog from "@/views/EditFileDevisDialog";
import SignDevisForm from "@/components/devis/SignDevisForm.vue";
import EditDevisName from "@/views/EditDevisName.vue";
import {AuthMixin} from "@/mixins/AuthMixin";

export default {
  name: "DevisView",
  components: {
    EditDevisName,
    EditFileDevisDialog,
    EditDateDevisDialog, EditMontantDevisDialog, EditDevisOperation, LoadingBanner, ErrorBanner, SignDevisForm
  },
  mixins: [DateUtilMixin, AuthMixin],
  async mounted() {
    this.loadDevis();
    if (this.referentiel.length === 0) {
      await this.$store.dispatch("referentiel/fetchReferentiel");
    }
    if (this.$store.getters["category/categories"].length === 0) {
      await this.$store.dispatch("category/fetchCategory");
    }
  },
  data() {
    return {
      loading: false,
      referentielModel: null,
      categoryModel: null,
      quantity: 1,
      observations: "",
      devis: null,
      presentation: "simple",
      duplicating: false,
      types: {
        "normal": "Normal",
        "import": "Importé",
      },
      montantTotal: 0.0,
      filterCategory: null,
    }
  },
  computed: {
    referentiel() {
      return this.$store.getters["referentiel/referentiel"];
    },
    categories() {
      let categories = this.$store.getters["category/categories"];
      categories = categories.filter(c => c.archived === false)
      return [{id: null, name: "Toutes les catégories"}, ...categories];
    },
    operations_referentiel() {
      let operations = this.referentiel.map((referetielItem) => {
        let operation = this.operations.find((operation) => operation.operation_name === referetielItem.referentiel_name);
        if(operation === undefined) {
          return {...referetielItem, operation_id: null, observations: "", quantity: null, key: referetielItem.id.toString() + "-null"};
        } else {
          return {...referetielItem, operation_id: operation.id,
            observations: operation.observations, quantity: operation.quantity,
            key: referetielItem.id.toString() + "-" + operation.id.toString()};
        }
      }).filter((referentielItem) => this.filterCategory !== null ? referentielItem.category?.id === this.filterCategory : true);
      let alreadyFilledOperations = operations.map(op => op.operation_id);
      let otherOperations = this.operations
          .filter((operation) => alreadyFilledOperations.indexOf(operation.id) === -1)
          .map((operation) => {
            return {...operation, operation_id: operation.id, key: "null-" + operation.id.toString()}
          })
          .filter((operation) => this.filterCategory !== null ? operation.category?.id === this.filterCategory : true);
      return [...operations, ...otherOperations];
    },
    filtered_referentiel: function () {
      return this.referentiel.filter((item) => {
        if (this.categoryModel !== null) {
          return item.category?.id === this.categoryModel;
        } else {
          return true;
        }
      });
    },
    operations() {
      let that = this;
      return this.devis === null ? [] : this.devis.operations.map(function (operation) {
        let price = that.filtered_referentiel === null ? null : that.filtered_referentiel.find(priceObj =>
            operation.code === priceObj.code
            && operation.category.id === priceObj.category.id
            && operation.description === priceObj.description);
        return {...operation, validated: price && price.validated === true};
      })
          .filter((operation) => this.filterCategory !== null ? operation.category?.id === this.filterCategory : true)
          .sort((a, b) => a.operation_name.localeCompare(b.operation_name, undefined, { sensitivity: "base"}));
    },
    hasInvalidOperation() {
      return this.operations.find(operation => operation.validated === false) !== undefined;
    },
    total_operations_ht() {
      let total = this.devis.operations.map((operation) => operation.quantity * operation.price).reduce((a, b) => a + b, 0);
      return total;
    },
    total_operations_ttc() {
      let total = this.devis.operations.map((operation) => operation.quantity * operation.price).reduce((a, b) => a + b, 0);
      return total * 1.021;
    },
    categories_total() {
      let categories_totals = [];
      let categories = new Set(this.devis.operations.map(operation => operation.category?.name ?? "Non défini"));
      for (const category of categories) {
        let total = {
          category: category,
          total: 0,
        };
        let operations_of_category = this.devis.operations.filter(operation => (operation.category?.name ?? "Non défini") === category);
        for (const operation of operations_of_category) {
          total.total += operation.price * operation.quantity;
        }
        categories_totals.push(total);
      }
      categories_totals = categories_totals.sort((a, b) => a.category.localeCompare(b.category, undefined, {sensitivity: 'base'}));
      return categories_totals;
    }
  },
  methods: {
    async addOperation() {
      let operation = {
        "devis": null,
        "category": null,
        "description": "",
        "code": "",
        "unit": "",
        "price": null,
        "quantity": 1,
      };
      operation.devis = this.devis.id;
      operation.category = this.referentielModel.category?.id;
      operation.description = this.referentielModel.description;
      operation.code = this.referentielModel.code;
      operation.unit = this.referentielModel.unit;
      operation.price = this.referentielModel.price;
      operation.quantity = this.quantity;
      operation.observations = this.observations;
      let newOperation = await this.$store.dispatch("operations/postOperation", operation);
      if (newOperation !== null) {
        this.referentielModel = null;
        this.observations = "";
        this.quantity = 1;
        this.loadDevis();
        this.$store.dispatch("annonce/annonceSuccess", "Opération ajouté au devis");
      }
    },
    async validateOperation(operation) {
      let operation_payload = {
        "devis": null,
        "category": null,
        "description": "",
        "code": "",
        "unit": "",
        "price": null,
        "quantity": 1,
      };
      operation_payload.devis = this.devis.id;
      operation_payload.category = operation.category?.id;
      operation_payload.description = operation.description;
      operation_payload.code = operation.code;
      operation_payload.unit = operation.unit;
      operation_payload.price = operation.price;
      operation_payload.quantity = operation.quantity;
      operation_payload.observations = operation.observations;
      let newOperation;
      if(operation.operation_id === null) {
        newOperation = await this.$store.dispatch("operations/postOperation", operation_payload);
      } else {
        operation_payload.id = operation.operation_id;
        newOperation = await this.$store.dispatch("operations/patchOperation", operation_payload);
      }
      if (newOperation !== null) {
        this.referentielModel = null;
        this.observations = "";
        this.quantity = 1;
        await this.loadDevis();
        this.$store.dispatch("annonce/annonceSuccess", "Opération ajouté au devis");
      }
    },
    async deleteOperation(operation) {
      if(this.presentation === 'complete') {
        operation.id = operation.operation_id;
      }
      if (operation.id === undefined) {
        console.log("Pas d'ID");
        return;
      }
      let result = await this.$store.dispatch("operations/deleteOperation", operation);
      if (result === "success") {
        await this.loadDevis();
        this.$store.dispatch("annonce/annonceSuccess", "Opération retiré au devis");
      }
    },
    async deleteDevis() {
      let result = await this.$store.dispatch("devis/deleteDevis", this.devis);
      if (result === "success") {
        await this.$router.push(`/dossier/${this.devis.dossier}`);
        this.$store.dispatch("annonce/annonceSuccess", "Devis supprimé");
      }
    },
    async loadDevis() {
      this.loading = true;
      let devisId = this.$route.params?.id;
      this.devis = await this.$store.dispatch("devis/getDevisById", {id: devisId});
      this.montantTotal = this.devis.total;
      this.loading = false;
    },
    async changeType() {
      let type = this.devis.type === "normal" ? "import" : "normal";
      this.loading = true;
      let devis = await this.$store.dispatch("devis/patchDevis", {id: this.devis.id, type})
      if (devis !== undefined) {
        this.devis = devis;
        this.montantTotal = this.devis.total;
        this.$store.dispatch("annonce/annonceSuccess", "Devis mis à jour.");
      }
      this.loading = false;
    },
    async duplicate() {
      this.duplicating = true;
      let newDevis = await this.$store.dispatch("devis/duplicate", {id: this.devis.id});
      this.duplicating = false;
      if (newDevis) {
        this.$store.dispatch("annonce/annonceSuccess", "Devis dupliqué !");
        this.$router.push(`/devis/${newDevis.id}`);
      }
    },
    async switchMainStatus() {
      this.duplicating = true;
      let newDevis = await this.$store.dispatch("devis/patchDevis", {id: this.devis.id, main: !this.devis.main});
      this.duplicating = false;
      if (newDevis) {
        this.$store.dispatch("annonce/annonceSuccess", "Ce devis sera désormais le devis principal.");
      }
    },
    formatNumber(value) {
      return Intl.NumberFormat("fr-FR", {style: "currency", currency: "EUR"}).format(value);
    }
  }
}
</script>
<style>
.primary-accent {
  background: #DFF2F0;
}
</style>
